var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cakeStoreConfig" },
    [
      _vm.currentRowMenu.is_support + "" === "1"
        ? _c(
            "el-tabs",
            {
              staticClass: "my-tab",
              on: {
                "tab-click": function ($event) {
                  return _vm.changeType()
                },
              },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "蛋糕到店", name: "cake_store" },
              }),
              _c("el-tab-pane", {
                attrs: { label: "蛋糕自由兑", name: "cake_store_zyd" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "profit-box" }, [
        _c(
          "div",
          { staticClass: "profit" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("菜单级规则")]),
            _c("div", [_vm._v("可见品牌：" + _vm._s(_vm.menuTotal) + "个")]),
            _c(
              "el-button",
              {
                attrs: { type: "text" },
                on: {
                  click: function ($event) {
                    return _vm.openDialog("menus")
                  },
                },
              },
              [_vm._v(" 查看明细 ")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "profit customer" },
          [
            _c("div", { staticClass: "title" }, [_vm._v("订单级利润率设置")]),
            _vm.cakeStoreType === "set"
              ? _vm._t("profit", [
                  _c(
                    "el-form",
                    {
                      ref: "profitForm",
                      attrs: {
                        model: _vm.profitForm,
                        rules: _vm.rules,
                        disabled: !_vm.hasEditRule,
                        inline: "",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "ratio", "label-width": "135px" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("span", [
                                _vm._v(
                                  "蛋糕" +
                                    _vm._s(
                                      _vm.activeTab === "cake_store"
                                        ? "到店"
                                        : "自由兑"
                                    ) +
                                    "利润率"
                                ),
                              ]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      "描述：利润率=1-结算价/售价，配置后仅显示该利润率及以上的电子券，仅影响显示不影响支付",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-info",
                                    staticStyle: { color: "#ccc" },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "200px" },
                              attrs: {
                                disabled: _vm.disableProfit,
                                clearable: "",
                              },
                              model: {
                                value: _vm.profitForm.ratio,
                                callback: function ($$v) {
                                  _vm.$set(_vm.profitForm, "ratio", $$v)
                                },
                                expression: "profitForm.ratio",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                          _vm.disableProfit
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: { type: "primary" },
                                  on: { click: _vm.toEditProfit },
                                },
                                [_vm._v(" 编辑 ")]
                              )
                            : [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    attrs: { type: "primary" },
                                    on: { click: _vm.confirmProfit },
                                  },
                                  [_vm._v(" 确定 ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.toEditProfit("cancel")
                                      },
                                    },
                                  },
                                  [_vm._v(" 取消 ")]
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              [
                _vm._v(
                  " 不满足利润率" +
                    _vm._s(_vm.activeTab === "cake_store" ? "商品" : "品牌") +
                    "：" +
                    _vm._s(_vm.unmetTotal) +
                    "个 "
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.openDialog("normal")
                      },
                    },
                  },
                  [_vm._v("查看明细")]
                ),
              ],
              1
            ),
          ],
          2
        ),
        _c("div", { staticClass: "profit" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.activeTab === "cake_store"
                    ? "订单级黑名单"
                    : "订单级品牌黑/白名单"
                ) +
                " "
            ),
          ]),
          _vm.activeTab === "cake_store"
            ? _c("div", [
                _vm._v(" 黑名单品牌：" + _vm._s(_vm.blackBrandTotal) + "个 "),
              ])
            : _c(
                "div",
                [
                  [0, 1].includes(_vm.action)
                    ? [
                        _vm._v(
                          " " +
                            _vm._s({ 0: "黑名单", 1: "白名单" }[_vm.action]) +
                            "品牌：" +
                            _vm._s(_vm.blackBrandTotal) +
                            "个 "
                        ),
                      ]
                    : [_vm._v(" 未设置 ")],
                ],
                2
              ),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.openDialog("viewBlack")
                    },
                  },
                },
                [
                  _vm._v(
                    " 查看" +
                      _vm._s(_vm.cakeStoreType === "set" ? "" : "明细") +
                      " "
                  ),
                ]
              ),
              _vm.cakeStoreType === "set"
                ? [
                    _c("el-divider", { attrs: { direction: "vertical" } }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openDialog("setBlack")
                          },
                        },
                      },
                      [_vm._v(" 设置 ")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "profit brand" },
        [
          _vm.activeTab === "cake_store"
            ? _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.tabChange },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: {
                      label: "可用品牌（" + _vm.totalCount + "）",
                      name: "0",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      label: "可用门店（" + _vm.storeTotal + "）",
                      name: "1",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      label: "可用商品（" + _vm.goodsTotal + "）",
                      name: "2",
                    },
                  }),
                ],
                1
              )
            : _c("div", { staticClass: "title" }, [
                _vm._v("可用品牌" + _vm._s(_vm.totalCount) + "个"),
              ]),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBrandList,
                  expression: "showBrandList",
                },
              ],
              ref: "searchForm",
              attrs: { model: _vm.searchForm, inline: "" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "城市", prop: "region_id" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "120px" },
                    attrs: {
                      options: _vm.citys,
                      props: {
                        checkStrictly: true,
                        emitPath: false,
                        expandTrigger: "hover",
                      },
                      clearable: "",
                      filterable: "",
                      "popper-class": "city-style",
                    },
                    model: {
                      value: _vm.searchForm.region_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "region_id", $$v)
                      },
                      expression: "searchForm.region_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "品牌分类", prop: "category_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        filterable: "",
                        multiple: "",
                        "collapse-tags": "",
                      },
                      model: {
                        value: _vm.searchForm.category_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "category_id", $$v)
                        },
                        expression: "searchForm.category_id",
                      },
                    },
                    _vm._l(_vm.categoryList, function (item) {
                      return _c("el-option", {
                        key: item.category_id,
                        attrs: {
                          label: item.category_name,
                          value: item.category_id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "品牌名称", prop: "brand_name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入品牌名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.brand_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "brand_name", $$v)
                      },
                      expression: "searchForm.brand_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.activeTab === "cake_store_zyd" &&
                        _vm.cakeStoreType === "set",
                      expression:
                        "activeTab === 'cake_store_zyd' && cakeStoreType === 'set'",
                    },
                  ],
                  attrs: { label: "利润率", prop: "min_ratio" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "90px" },
                    attrs: { placeholder: "最低", clearable: "" },
                    on: {
                      change: function ($event) {
                        return _vm.changeInput("searchForm", "min_ratio")
                      },
                    },
                    model: {
                      value: _vm.searchForm.min_ratio,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "min_ratio",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.min_ratio",
                    },
                  }),
                  _vm._v(" - "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "max_ratio" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "90px" },
                        attrs: { placeholder: "最高", clearable: "" },
                        model: {
                          value: _vm.searchForm.max_ratio,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "max_ratio", $$v)
                          },
                          expression: "searchForm.max_ratio",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.searchData },
                    },
                    [_vm._v(" 搜索 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.searchData("reset")
                        },
                      },
                    },
                    [_vm._v(" 重置 ")]
                  ),
                  _vm.hasExportRole
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            exportLoading: _vm.exportLoading,
                            type: "success",
                          },
                          on: { click: _vm.exportData },
                        },
                        [_vm._v(" 导出 ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBrandList,
                  expression: "showBrandList",
                },
              ],
              staticStyle: { "text-align": "right", "margin-bottom": "10px" },
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-size": _vm.searchForm.pagesize,
                  "page-sizes": [10, 20, 30, 40, 50, 100],
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": function (size) {
                    return _vm.sizeChange("searchForm", size)
                  },
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBrandList,
                  expression: "showBrandList",
                },
              ],
              ref: "myTable",
              staticClass: "myTable",
              attrs: {
                "header-cell-style": {
                  background: "#f1f1f1",
                  color: "#333333",
                },
                data: _vm.tableData,
                height: "58vh",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "brand_id", width: "80px", label: "ID" },
              }),
              _c("el-table-column", {
                attrs: { prop: "category_name", label: "分类" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: _vm.activeTab === "cake_store" ? "brand_name" : "name",
                  label: "品牌",
                },
              }),
              _vm.activeTab === "cake_store_zyd" && _vm.cakeStoreType === "set"
                ? _c("el-table-column", {
                    attrs: { prop: "discount", label: "折扣/利润率" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    border: "",
                                    data: scope.row.discount,
                                    "show-header": false,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { prop: "name" },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      262644131
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  prop: "city",
                  label: "覆盖城市",
                  "min-width": "180px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.activeTab === "cake_store"
                          ? _c("div", { staticClass: "wrapper" }, [
                              _c(
                                "div",
                                { staticClass: "text" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openCityDialog(
                                            scope.row.city_tree
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 更多 ")]
                                  ),
                                  _vm._l(
                                    scope.row.city_name,
                                    function (item, index) {
                                      return [
                                        _vm._v(
                                          _vm._s(index !== 0 ? "，" : "") +
                                            _vm._s(item)
                                        ),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ])
                          : _c(
                              "el-table",
                              {
                                attrs: {
                                  border: "",
                                  "show-header": false,
                                  data: scope.row.city,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { prop: "name" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope_c) {
                                          return _vm._l(
                                            scope_c.row,
                                            function (item, index) {
                                              return _c(
                                                "span",
                                                { key: index },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.name) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          )
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.activeTab === "cake_store" && _vm.activeName === "1"
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "storeForm",
                      attrs: { model: _vm.storeForm, inline: "" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市", prop: "region_id" } },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              options: _vm.citys,
                              props: {
                                checkStrictly: true,
                                emitPath: false,
                                expandTrigger: "hover",
                              },
                              clearable: "",
                              filterable: "",
                              "popper-class": "city-style",
                            },
                            on: { change: _vm.getCityBrand },
                            model: {
                              value: _vm.storeForm.region_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.storeForm, "region_id", $$v)
                              },
                              expression: "storeForm.region_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "分类", prop: "category_id" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                              },
                              model: {
                                value: _vm.storeForm.category_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.storeForm, "category_id", $$v)
                                },
                                expression: "storeForm.category_id",
                              },
                            },
                            _vm._l(_vm.categoryList, function (item) {
                              return _c("el-option", {
                                key: item.category_id,
                                attrs: {
                                  label: item.category_name,
                                  value: item.category_id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品品牌", prop: "brand_id" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.storeForm.brand_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.storeForm, "brand_id", $$v)
                                },
                                expression: "storeForm.brand_id",
                              },
                            },
                            _vm._l(_vm.brandList, function (item) {
                              return _c("el-option", {
                                key: item.brand_id,
                                attrs: {
                                  label: item.name,
                                  value: item.brand_id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "门店名称", prop: "store_name" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入", clearable: "" },
                            model: {
                              value: _vm.storeForm.store_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.storeForm, "store_name", $$v)
                              },
                              expression: "storeForm.store_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品ID", prop: "goods_id" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入", clearable: "" },
                            model: {
                              value: _vm.storeForm.goods_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.storeForm, "goods_id", $$v)
                              },
                              expression: "storeForm.goods_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                              },
                              on: { click: _vm.searchStoreData },
                            },
                            [_vm._v(" 搜索 ")]
                          ),
                          _vm.hasExportRole
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    loading: _vm.exportStoreLoading,
                                  },
                                  on: { click: _vm.exportStoreData },
                                },
                                [_vm._v(" 导出 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "margin-bottom": "10px",
                      },
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          layout: "total, sizes, prev, pager, next, jumper",
                          "current-page": _vm.storeForm.page,
                          "page-size": _vm.storeForm.pagesize,
                          "page-sizes": [10, 20, 30, 40, 50, 100],
                          total: _vm.storeTotal,
                        },
                        on: {
                          "size-change": _vm.sizeChangeStore,
                          "current-change": _vm.pageChangeStore,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      key: _vm.activeName,
                      staticClass: "myTable",
                      attrs: {
                        "header-cell-style": {
                          background: "#f1f1f1",
                          color: "#333333",
                        },
                        data: _vm.storeList,
                        height: "58vh",
                        stripe: "",
                        border: "",
                      },
                      on: { "sort-change": _vm.sortStoreChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "门店图片",
                          width: "80px",
                          prop: "brand_img",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-image", {
                                    attrs: {
                                      src: scope.row.brand_img,
                                      "preview-src-list": [scope.row.brand_img],
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1458668434
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "门店名称",
                          prop: "name",
                          "min-width": "220px",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "分类",
                          width: "100px",
                          prop: "category_name",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(scope.row.category_name || "-") +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3026790616
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "品牌", prop: "brand_name" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "地址",
                          "min-width": "220px",
                          prop: "address",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "城市", width: "100px", prop: "city" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "商品数量",
                          width: "100px",
                          align: "center",
                          prop: "goods_count",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.activeTab === "cake_store" && _vm.activeName === "2"
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "goodsForm",
                      attrs: { model: _vm.goodsForm, inline: "" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市", prop: "region_id" } },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              options: _vm.citys,
                              props: {
                                checkStrictly: true,
                                emitPath: false,
                                expandTrigger: "hover",
                              },
                              clearable: "",
                              filterable: "",
                              "popper-class": "city-style",
                            },
                            on: { change: _vm.getCityBrand },
                            model: {
                              value: _vm.goodsForm.region_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.goodsForm, "region_id", $$v)
                              },
                              expression: "goodsForm.region_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品ID", prop: "goods_id" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入", clearable: "" },
                            model: {
                              value: _vm.goodsForm.goods_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.goodsForm,
                                  "goods_id",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "goodsForm.goods_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入", clearable: "" },
                            model: {
                              value: _vm.goodsForm.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.goodsForm,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "goodsForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "分类", prop: "category_id" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                              },
                              model: {
                                value: _vm.goodsForm.category_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.goodsForm, "category_id", $$v)
                                },
                                expression: "goodsForm.category_id",
                              },
                            },
                            _vm._l(_vm.categoryList, function (item) {
                              return _c("el-option", {
                                key: item.category_id,
                                attrs: {
                                  label: item.category_name,
                                  value: item.category_id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品品牌", prop: "brand_id" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.goodsForm.brand_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.goodsForm, "brand_id", $$v)
                                },
                                expression: "goodsForm.brand_id",
                              },
                            },
                            _vm._l(_vm.brandList, function (item) {
                              return _c("el-option", {
                                key: item.brand_id,
                                attrs: {
                                  label: item.name,
                                  value: item.brand_id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "门店ID", prop: "store_id" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入", clearable: "" },
                            model: {
                              value: _vm.goodsForm.store_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.goodsForm, "store_id", $$v)
                              },
                              expression: "goodsForm.store_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.$hasBtnRoles("/products/cake-store/show-price") &&
                      _vm.cakeStoreType === "set"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: "折扣", prop: "profit_ratio_gt" },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "90px" },
                                attrs: { placeholder: "最低", clearable: "" },
                                model: {
                                  value: _vm.goodsForm.profit_ratio_gt,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.goodsForm,
                                      "profit_ratio_gt",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "goodsForm.profit_ratio_gt",
                                },
                              }),
                              _vm._v(" - "),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "profit_ratio_lt" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "90px" },
                                    attrs: {
                                      placeholder: "最高",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.goodsForm.profit_ratio_lt,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.goodsForm,
                                          "profit_ratio_lt",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "goodsForm.profit_ratio_lt",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "限购数量", prop: "min_buy_limit" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "90px" },
                            attrs: { placeholder: "最低", clearable: "" },
                            model: {
                              value: _vm.goodsForm.min_buy_limit,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.goodsForm,
                                  "min_buy_limit",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "goodsForm.min_buy_limit",
                            },
                          }),
                          _vm._v(" - "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "max_buy_limit" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "90px" },
                                attrs: { placeholder: "最高", clearable: "" },
                                model: {
                                  value: _vm.goodsForm.max_buy_limit,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.goodsForm,
                                      "max_buy_limit",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "goodsForm.max_buy_limit",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                              },
                              on: { click: _vm.searchGoodsData },
                            },
                            [_vm._v(" 搜索 ")]
                          ),
                          _vm.hasExportRole
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    loading: _vm.exportGoodsLoading,
                                  },
                                  on: { click: _vm.exportGoodsData },
                                },
                                [_vm._v(" 导出 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "margin-bottom": "10px",
                      },
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          layout: "total, sizes, prev, pager, next, jumper",
                          "current-page": _vm.goodsForm.page,
                          "page-size": _vm.goodsForm.pagesize,
                          "page-sizes": [10, 20, 30, 40, 50, 100],
                          total: _vm.goodsTotal,
                        },
                        on: {
                          "size-change": _vm.sizeChangeGoods,
                          "current-change": _vm.pageChangeGoods,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      key: _vm.activeName,
                      staticClass: "myTable",
                      attrs: {
                        "header-cell-style": {
                          background: "#f1f1f1",
                          color: "#333333",
                        },
                        data: _vm.goodsList,
                        height: "58vh",
                        stripe: "",
                        border: "",
                      },
                      on: { "sort-change": _vm.sortGoodsChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "商品图片",
                          width: "100px",
                          prop: "goods_img",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-image", {
                                    attrs: {
                                      src: scope.row.goods_img,
                                      "preview-src-list": [scope.row.goods_img],
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          247235026
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "商品信息", "min-width": "230px" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { "white-space": "nowrap" },
                                    },
                                    [
                                      _vm._v(" 名称： "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openGoodsDetail(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(scope.row.name))]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", [
                                    _vm._v(
                                      "品牌：" + _vm._s(scope.row.brand_name)
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      "商品ID：" + _vm._s(scope.row.goods_id)
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    [
                                      _vm._v(" 城市： "),
                                      _vm._l(
                                        scope.row.city_tree,
                                        function (item, index) {
                                          return _c("span", { key: index }, [
                                            _vm._v(_vm._s(item)),
                                          ])
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _c("div", [
                                    _vm._v(
                                      "分类：" +
                                        _vm._s(scope.row.category_name || "-")
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2454528249
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "通用门店",
                          width: "110px",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { padding: "0" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toStoreTab(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.store_ids_count))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3008707689
                        ),
                      }),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label: "售价",
                            prop: "sell_price",
                            align: "center",
                            sortable: "custom",
                            "sort-orders": ["descending", "ascending", null],
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "header" },
                            [
                              _c("span", [_vm._v("售价")]),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "商品在商城中销售的价格",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon el-icon-warning-outline",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _vm.$hasBtnRoles("/products/cake-store/show-price")
                        ? _c(
                            "el-table-column",
                            {
                              attrs: {
                                label: "市场价",
                                prop: "original_price",
                                align: "center",
                                sortable: "custom",
                                "sort-orders": [
                                  "descending",
                                  "ascending",
                                  null,
                                ],
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "header" },
                                [
                                  _c("span", [_vm._v("市场价")]),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "该商品在市场上销售的售价",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon el-icon-warning-outline",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.$hasBtnRoles("/products/cake-store/show-price") &&
                      _vm.cakeStoreType === "set"
                        ? _c(
                            "el-table-column",
                            {
                              attrs: {
                                label: "结算价",
                                prop: "settle_price",
                                align: "center",
                                sortable: "custom",
                                "sort-orders": [
                                  "descending",
                                  "ascending",
                                  null,
                                ],
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "header" },
                                [
                                  _c("span", [_vm._v("结算价")]),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "平台与渠道结算的价格",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon el-icon-warning-outline",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.$hasBtnRoles("/products/cake-store/show-price") &&
                      _vm.cakeStoreType === "set"
                        ? _c("el-table-column", {
                            attrs: {
                              label: "折扣",
                              prop: "channel_pre_discount",
                              align: "center",
                              sortable: "custom",
                              "sort-orders": ["descending", "ascending", null],
                            },
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: { label: "其他说明", prop: "gift" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(scope.row.need_appointment_des)
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(_vm._s(scope.row.delivery_memo)),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      style: {
                                        color:
                                          scope.row.cake_store_limit_id == 1
                                            ? "red"
                                            : "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(scope.row.limit_tips) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2759324614
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showCityDialog,
            title: "覆盖城市",
            "lock-scroll": "",
            "append-to-body": "",
            top: "30px",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCityDialog = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "treeContent" },
            [
              _c(
                "div",
                { staticClass: "filter-input" },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "输入关键字进行过滤" },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "filterText",
                    },
                  }),
                ],
                1
              ),
              _c("el-tree", {
                ref: "tree",
                staticClass: "filter-tree",
                attrs: {
                  data: _vm.cityList,
                  props: {
                    children: "children",
                    label: "label",
                  },
                  "filter-node-method": _vm.filterNode,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showCityDialog = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.detailDialog,
            title: _vm.dialogTitle,
            "lock-scroll": "",
            "append-to-body": "",
            top: "20px",
            width: "1150px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialog = $event
            },
            close: _vm.onDetailClose,
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "min-height": "500px" } },
            [
              _vm.activeTab === "cake_store_zyd" &&
              ["viewBlack", "setBlack"].includes(_vm.dialogType)
                ? _c(
                    "el-form",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              (_vm.menuType === "customerSet"
                                ? "客户"
                                : "订单") + "级品牌黑/白名单",
                            required: "",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.changeAction },
                              model: {
                                value: _vm.dialogAction,
                                callback: function ($$v) {
                                  _vm.dialogAction = $$v
                                },
                                expression: "dialogAction",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "margin-right": "50px" },
                                  attrs: { label: 1 },
                                },
                                [_vm._v("设置白名单品牌")]
                              ),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("设置黑名单品牌"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: [0, 1].includes(_vm.dialogAction),
                      expression: "[0, 1].includes(dialogAction)",
                    },
                  ],
                },
                [
                  _vm.dialogType === "setBlack"
                    ? _c(
                        "el-tabs",
                        {
                          attrs: { type: "card" },
                          on: { "tab-click": _vm.changeBrandTab },
                          model: {
                            value: _vm.activeBrand,
                            callback: function ($$v) {
                              _vm.activeBrand = $$v
                            },
                            expression: "activeBrand",
                          },
                        },
                        [
                          _c("el-tab-pane", {
                            attrs: {
                              name: "allow_brand",
                              label:
                                (_vm.dialogAction === 1
                                  ? "可选品牌库"
                                  : "可用品牌") +
                                "（" +
                                _vm.allow_brand_total +
                                "）",
                            },
                          }),
                          _c("el-tab-pane", {
                            attrs: {
                              name: "not_allow_brand",
                              label:
                                (_vm.dialogAction === 1
                                  ? "白名单品牌"
                                  : "黑名单品牌") +
                                "（" +
                                _vm.not_allow_brand_total +
                                "）",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form",
                    {
                      ref: "dialogForm",
                      attrs: { model: _vm.dialogForm, inline: "" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市", prop: "region_id" } },
                        [
                          _c("el-cascader", {
                            attrs: {
                              options: _vm.citys,
                              props: {
                                checkStrictly: true,
                                emitPath: false,
                                expandTrigger: "hover",
                              },
                              clearable: "",
                              filterable: "",
                              "popper-class": "city-style",
                            },
                            model: {
                              value: _vm.dialogForm.region_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogForm, "region_id", $$v)
                              },
                              expression: "dialogForm.region_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "品牌分类", prop: "category_id" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                              },
                              model: {
                                value: _vm.dialogForm.category_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dialogForm, "category_id", $$v)
                                },
                                expression: "dialogForm.category_id",
                              },
                            },
                            _vm._l(_vm.categoryList, function (item) {
                              return _c("el-option", {
                                key: item.category_id,
                                attrs: {
                                  label: item.category_name,
                                  value: item.category_id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "品牌名称", prop: "brand_name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入品牌名称",
                              clearable: "",
                            },
                            model: {
                              value: _vm.dialogForm.brand_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogForm, "brand_name", $$v)
                              },
                              expression: "dialogForm.brand_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.activeTab === "cake_store_zyd" &&
                                _vm.$hasBtnRoles(
                                  "/orders/order/order-rule-sensitive-data"
                                ),
                              expression:
                                "\n\t\t\t\t\t\t\tactiveTab === 'cake_store_zyd' &&\n\t\t\t\t\t\t\t\t$hasBtnRoles('/orders/order/order-rule-sensitive-data')\n\t\t\t\t\t\t",
                            },
                          ],
                          attrs: { label: "利润率", prop: "min_ratio" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "90px" },
                            attrs: { placeholder: "最低", clearable: "" },
                            on: { change: _vm.changeDialogInput },
                            model: {
                              value: _vm.dialogForm.min_ratio,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogForm, "min_ratio", $$v)
                              },
                              expression: "dialogForm.min_ratio",
                            },
                          }),
                          _vm._v(" - "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "max_ratio" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "90px" },
                                attrs: { placeholder: "最高", clearable: "" },
                                on: { change: _vm.changeDialogInput },
                                model: {
                                  value: _vm.dialogForm.max_ratio,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dialogForm,
                                      "max_ratio",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "dialogForm.max_ratio",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.dialogSearch(1)
                                },
                              },
                            },
                            [_vm._v(" 搜索 ")]
                          ),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.dialogSearch(1, { type: "reset" })
                                },
                              },
                            },
                            [_vm._v(" 重置 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.dialogType === "setBlack"
                    ? _c(
                        "div",
                        { staticStyle: { "margin-bottom": "10px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: !_vm.hasEditRule,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.block("batch")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "批量" +
                                  _vm._s(
                                    _vm.activeBrand === "allow_brand"
                                      ? _vm.dialogAction === 1
                                        ? "设为白名单"
                                        : "拉黑"
                                      : _vm.dialogAction === 1
                                      ? "移除白名单"
                                      : "设为可用"
                                  )
                              ),
                            ]
                          ),
                          _vm.activeTab === "cake_store_zyd" &&
                          _vm.ruleType === "order"
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    disabled: !_vm.hasEditRule,
                                    loading: _vm.syncLoading,
                                  },
                                  on: { click: _vm.syncCustomerList },
                                },
                                [
                                  _vm._v(
                                    "同步客户级" +
                                      _vm._s(
                                        _vm.dialogAction === 1 ? "白" : "黑"
                                      ) +
                                      "名单"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-table",
                    {
                      staticClass: "myTable",
                      attrs: {
                        "header-cell-style": {
                          background: "#f1f1f1",
                          color: "#333333",
                        },
                        data: _vm.dialogTableData,
                        height: "59vh",
                        border: "",
                      },
                    },
                    [
                      _vm.dialogType === "setBlack"
                        ? _c(
                            "el-table-column",
                            {
                              key: "selected",
                              attrs: { prop: "selected", width: "55" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-checkbox", {
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeRowStatus(
                                                scope.row
                                              )
                                            },
                                          },
                                          model: {
                                            value: scope.row.selected,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "selected",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.selected",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1112059672
                              ),
                            },
                            [
                              _c(
                                "template",
                                { slot: "header" },
                                [
                                  _c("el-checkbox", {
                                    attrs: {
                                      indeterminate: _vm.isIndeterminate,
                                    },
                                    on: { change: _vm.changeAllStatus },
                                    model: {
                                      value: _vm.checkAll,
                                      callback: function ($$v) {
                                        _vm.checkAll = $$v
                                      },
                                      expression: "checkAll",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _c("el-table-column", {
                        key: "brand_id",
                        attrs: { prop: "brand_id", width: "80px", label: "ID" },
                      }),
                      _c("el-table-column", {
                        key: "category_name",
                        attrs: { prop: "category_name", label: "分类" },
                      }),
                      _c("el-table-column", {
                        key: "brand",
                        attrs: {
                          prop:
                            _vm.activeTab === "cake_store"
                              ? "brand_name"
                              : "name",
                          label: "品牌",
                        },
                      }),
                      _vm.activeTab === "cake_store_zyd" &&
                      _vm.$hasBtnRoles(
                        "/orders/order/order-rule-sensitive-data"
                      )
                        ? _c("el-table-column", {
                            key: "discount",
                            attrs: { prop: "discount", label: "折扣/利润率" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-table",
                                        {
                                          attrs: {
                                            border: "",
                                            data: scope.row.discount,
                                            "show-header": false,
                                          },
                                        },
                                        [
                                          _c("el-table-column", {
                                            attrs: { prop: "name" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              262644131
                            ),
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        key: "city",
                        attrs: {
                          prop: "city",
                          label: "覆盖城市",
                          "min-width": "180px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.activeTab === "cake_store"
                                  ? _c("div", { staticClass: "wrapper" }, [
                                      _c(
                                        "div",
                                        { staticClass: "text" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openCityDialog(
                                                    scope.row.city_tree
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 更多 ")]
                                          ),
                                          _vm._l(
                                            scope.row.city_name,
                                            function (item, index) {
                                              return [
                                                _vm._v(
                                                  _vm._s(
                                                    index !== 0 ? "，" : ""
                                                  ) + _vm._s(item)
                                                ),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ])
                                  : _c(
                                      "el-table",
                                      {
                                        attrs: {
                                          border: "",
                                          "show-header": false,
                                          data: scope.row.city,
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          key: "name",
                                          attrs: { prop: "name" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope_c) {
                                                  return _vm._l(
                                                    scope_c.row,
                                                    function (item, index) {
                                                      return _c(
                                                        "span",
                                                        { key: index },
                                                        [
                                                          _vm.dialogType ===
                                                          "setBlack"
                                                            ? _c(
                                                                "el-checkbox",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "10px",
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.changeCityStatus(
                                                                          scope.row
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.selected,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "selected",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.selected",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item.name
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.name
                                                                    )
                                                                ),
                                                              ]),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  )
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm.dialogType === "setBlack"
                        ? _c("el-table-column", {
                            key: "action",
                            attrs: {
                              prop: "action",
                              width: "90px",
                              label: "操作",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            disabled: !_vm.hasEditRule,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.block(
                                                "single",
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.activeBrand === "allow_brand"
                                                ? _vm.dialogAction === 1
                                                  ? "设为白名单"
                                                  : "拉黑"
                                                : _vm.dialogAction === 1
                                                ? "移除白名单"
                                                : "设为可用"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              103138558
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "margin-top": "10px",
                      },
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          layout: "total, sizes, prev, pager, next, jumper",
                          "current-page": _vm.dialogForm.page,
                          "page-size": _vm.dialogForm.pagesize,
                          "page-sizes": [10, 20, 30, 40, 50, 100],
                          total: _vm.dialogTotalCount,
                        },
                        on: {
                          "size-change": function (size) {
                            return _vm.sizeChange("dialogForm", size)
                          },
                          "current-change": _vm.dialogSearch,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.goodsDetailDialog,
            title: "预览",
            "lock-scroll": "",
            "append-to-body": "",
            top: "30px",
            width: "380px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.goodsDetailDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "goods-detail" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c(
                  "el-carousel",
                  {
                    attrs: {
                      trigger: "click",
                      "initial-index": 1,
                      height: "320px",
                    },
                  },
                  _vm._l(_vm.goodsInfo.imgBanner, function (item, index) {
                    return _c("el-carousel-item", { key: index }, [
                      item
                        ? _c("img", {
                            staticStyle: {
                              width: "100%",
                              height: "100%",
                              "object-fit": "contain",
                            },
                            attrs: { src: item },
                          })
                        : _vm._e(),
                    ])
                  }),
                  1
                ),
                _c("div", { staticClass: "title" }, [
                  _vm._v(" " + _vm._s(_vm.goodsInfo.name) + " "),
                ]),
                _c("div", { staticClass: "price" }, [
                  _vm._v(" " + _vm._s(_vm.goodsInfo.sellPrice) + "点 "),
                  _c("span", [_vm._v(_vm._s(_vm.goodsInfo.originalPrice))]),
                ]),
                _vm.goodsInfo.canRefund == 1
                  ? _c("div", { staticClass: "title" }, [
                      _vm._v(" 如券码未使用，过期前24小时可退款，请放心购买 "),
                    ])
                  : _vm._e(),
                _vm.goodsInfo.useMemo
                  ? _c("div", { staticClass: "title" }, [
                      _vm._v(" 使用：" + _vm._s(_vm.goodsInfo.useMemo) + " "),
                    ])
                  : _vm._e(),
                _vm.goodsInfo.memo
                  ? _c("div", { staticClass: "title" }, [
                      _vm._v(" 套餐说明：" + _vm._s(_vm.goodsInfo.memo) + " "),
                    ])
                  : _vm._e(),
                _vm.goodsInfo.butNote && _vm.goodsInfo.butNote.length
                  ? _c("div", { staticClass: "title" }, [
                      _vm._v(" 购买须知： "),
                    ])
                  : _vm._e(),
                _vm._l(_vm.goodsInfo.butNote, function (item, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                      _vm._l(item.content, function (items, idx) {
                        return _c("span", { key: idx }, [
                          _vm._v(" " + _vm._s(items) + " "),
                        ])
                      }),
                    ],
                    2
                  )
                }),
              ],
              2
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }